module.exports = __webpack_public_path__ + "static/hero-02-2c01ea63c21dab5993dc11accd69c0e1.jpg";